/*
 * Maintained by Gexiaolei
 * 需求清单
 */
export default {
  fixed: [
    // 前置页面
    {
      name: 'create-require-list',
      path: 'require-list/create',
      component: () => import(/* webpackChunkName: "create-require-list" */'../routes/require-list/import/index.vue'),
      meta: {
        title: {
          'zh-CN': '需求清单',
          en: '需求清单_en',
          jp: '需求清单_jp'
        },
        spmB: 'b478',
        isNewHeader: true,
        menuCode: '/require/list'
      }
    },
    {
      name: 'create-requisition',
      path: '/create/requisition',
      component: () => import(/* webpackChunkName: "create-requisition" */'../routes/require-list/create/requisition/requisition.vue'),
      meta: {
        // title: '我的领用单',
        title: {
          'zh-CN': '创建领用单',
          en: '创建领用单_en',
          jp: '创建领用单_jp'
        },
        isNewHeader: true,
        spmB: 'b474',
        menuCode: '/require/list'
      }
    },
    {
      name: 'create-application',
      path: '/create/application',
      component: () => import(/* webpackChunkName: "create-application" */'../routes/require-list/create/application/application.vue'),
      meta: {
        // title: '我的领用单',
        title: {
          'zh-CN': '创建申请单',
          en: '创建申请单_en',
          jp: '创建申请单_jp'
        },
        isNewHeader: true,
        spmB: 'b475',
        menuCode: '/require/list'
      }
    },
    {
      name: 'require-list-detail',
      path: 'require-list/detail',
      component: () => import(/* webpackChunkName: "require-list-detail" */'../routes/require-list/detail/detail.vue'),
      meta: {
        title: {
          'zh-CN': '需求清单详情',
          en: '需求清单详情_en',
          jp: '需求清单详情_jp'
        },
        isNewHeader: true,
        spmB: 'b476',
        menuCode: '/require/list'
      }
    },
    {
      name: 'require-list-draft-detail',
      path: 'require-list/draft-detail',
      component: () => import(/* webpackChunkName: "require-list-draft-detail" */'../routes/require-list/detail/draft.vue'),
      meta: {
        title: {
          'zh-CN': '需求清单详情',
          en: '需求清单详情_en',
          jp: '需求清单详情_jp'
        },
        i18nCode: 'create-require-list',
        isNewHeader: true,
        spmB: 'b477',
        menuCode: '/require/list'
      }
    },
    {
      name: 'require-list-draft-edit',
      path: 'require-list/draft-edit',
      component: () => import(/* webpackChunkName: "create-require-list" */'../routes/require-list/import/index.vue'),
      meta: {
        title: {
          'zh-CN': '需求清单草稿',
          en: '需求清单草稿_en',
          jp: '需求清单草稿_jp'
        },
        i18nCode: 'create-require-list',
        isNewHeader: true,
        spmB: 'b479',
        menuCode: '/require/list'
      }
    }
  ],
  fluid: [
    {
      name: 'require-list',
      path: 'require/list',
      component: () => import(/* webpackChunkName: "require-list" */'../routes/require-list/list/index.vue'),
      meta: {
        title: {
          'zh-CN': '我的需求清单',
          en: '我的需求清单_en',
          jp: '我的需求清单_jp'
        },
        spmB: 'b480',
        isNewHeader: true
      }
    }
  ]
}
